'use client';

import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { noteSuggestionsAtomFamily } from '../atoms/noteSuggestionsAtoms';
import { useMutateRecordNoteSuggestionFeedback } from '../mutation';

/**
 * Imperatively clears pending note suggestions for a session and reports
 * `skipped_edit` for every strategy that still has unresolved applications.
 * Used wherever an action invalidates the BE-supplied char offsets — typing
 * into the editor, or Ask AI's "Replace note" swapping the underlying text.
 */
export function useDismissPendingNoteSuggestions(sessionId: string) {
  const [suggestions, setSuggestions] = useAtom(noteSuggestionsAtomFamily(sessionId));
  const { mutate: recordFeedback } = useMutateRecordNoteSuggestionFeedback();

  return useCallback(() => {
    if (!suggestions || suggestions.mode !== 'ask') return;

    suggestions.strategies
      .filter((s) => s.applications.length > 0)
      .forEach((strategy) => {
        if (strategy.suggestion_id) {
          recordFeedback({
            suggestionId: strategy.suggestion_id,
            feedback: 'skipped_edit',
          });
        }
      });
    setSuggestions(null);
  }, [suggestions, setSuggestions, recordFeedback]);
}
